<template>
  <div>
    <div v-if="selectedUserName">
      <input disabled :value="`${selectedUserName}`"/>
      <button type="button" class="btn-icon grey-to-red" @click="removeUser" id="remove-user">
        <icon class="times"></icon>
      </button>
    </div>
    <a-select v-else-if="isPortalUser"
        :options="portalUserOptions"
        @input="selectUserAccount"
        bind-by-object>
    </a-select>
    <search-input v-else v-model="q" @reset="resetSearch" @keydown.esc.stop="resetSearchOrModal" placeholder="Search" id="search-users"/>

    <!-- Search results show as dropdown list -->
    <matrix
      v-if="hasQ"
      class="search-list"
      has-data>
      <template slot="table-body">
        <t-row class="prompt" v-if="searchProgress">
          <t-column>
            <strong>{{searchProgress}}</strong>
          </t-column>
        </t-row>

        <!-- Search results from query -->
        <row v-for="userAccount in usersFromQuery" v-bind:key="userAccount.id">
          <prefix size="45">
            <avatar :user=userAccount :current-user-id="currentUserId"></avatar>
          </prefix>

          <column class="row-title">
            <div class="details link-tag" style="display: flex; flex-direction: column;">
              <strong class="crayon blue">{{userAccount.first_name}} {{userAccount.last_name}}</strong>
              {{userAccount.email}}
            </div>
          </column>

          <suffix class="sz100">
            <button class="btn blue" @click="selectUserAccount(userAccount)">Select</button>
          </suffix>
        </row>

        <!-- Always display Relative User in search results -->
        <row>
          <column class="row-title">
            <div class="details link-tag">
              <strong class="crayon blue">{{relativeUserText}}</strong>
            </div>
          </column>
          <suffix class="sz100">
            <button class="btn blue" @click="selectUserAccount(relativeUser)">Select</button>
          </suffix>
        </row>
      </template>
    </matrix>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Avatar from "../../../common/components/avatar.vue";
import SearchUsersMixin from "~/mixins/searchUsersMixin";
import {ModelType} from "~/enums/modelType";
import {IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";

export default Vue.extend( {
  components: {Avatar},
  mixins: [
    SearchUsersMixin,
  ],
  props: {
    value: null,
    referencedControl:{
      default: null
    },
    referenced_value_id: null,
    relativeUserText:{
      type: String,
      default: "Relative User"
    }
  },
  data: function () {
    return {
      selectedUser: { userName: null, userId: null },
    };
  },
  beforeMount() {
    if (this.value) this.selectedUser.userName = this.value;
    if (this.referenced_value_id) this.selectedUser.userId = this.referenced_id;
  },
  computed: {
    portalUserOptions(): IVOptionSetLocal {
        return {
          valueKey: 'userId',
          labelKey: 'labelText',
          options: [this.relativeUser]
        }
    },
    isPortalUser(){
      return this.referencedControl.user_type === ModelType.PortalUser
    },
    relativeUser(): object {
      return { userName: 'relative_user', userId: null, labelText: this.relativeUserText};
    },
    selectedUserName(): string | null {
      if (!this.selectedUser.userName) return null;
      if (this.selectedUser.userName === 'relative_user') return this.relativeUserText;
      return this.selectedUser.userName;
    },
  },
  methods: {
    selectUserAccount(user): void {
      const name = user.userName ? user.userName : `${user.first_name} ${user.last_name}`;
      const userAccount = {
        userName: name,
        userId: user.id
      };

      this.selectedUser = userAccount;
      this.setValue();
      this.resetSearch();
    },
    removeUser(): void {
      this.selectedUser = { userName: null, userId: null };
      this.setValue();
    },
    setValue() {
      let emittedValue = this.selectedUser;
      this.$emit('changed', emittedValue);
    },
  },
});
</script>

